import React from "react";
import styles from './Footer.module.css'

const Footer = () => {
  return (
    <div className={styles.main}>
      <p>Terms of Service Privacy Police Cookie Policy</p>
      <p> Accessibility Ads info More...</p>
      <p> © 2023 Twitter, Inc.</p>
     
    </div>
  );
};

export default Footer;
